/**
 * Centralized application configuration
 * Shared with admin project backend
 */

const getRequiredEnv = (keys: string[], label: string): string => {
  for (const key of keys) {
    const value = import.meta.env[key as keyof ImportMetaEnv];
    if (typeof value === 'string' && value.trim().length > 0) {
      return value;
    }
  }

  throw new Error(`Missing required environment variable for ${label}: ${keys.join(' or ')}`);
};

const supabaseUrl = getRequiredEnv(
  ['VITE_SUPABASE_URL'],
  'Supabase URL'
);

const supabaseAnonKey = getRequiredEnv(
  ['VITE_SUPABASE_ANON_KEY', 'VITE_SUPABASE_PUBLISHABLE_KEY'],
  'Supabase anon key'
);

export const APP_CONFIG = {
  supabase: {
    url: supabaseUrl,
    anonKey: supabaseAnonKey,
    functionsUrl: `${supabaseUrl}/functions/v1`
  },
  app: {
    name: 'Handel',
    version: '1.0.0',
    defaultSearchRadius: 5000, // meters
    maxSearchRadius: 15000 // meters
  },
  features: {
    a2hsOnboarding: true // Enable "Add to Home Screen" step in onboarding
  }
} as const;
